// extracted by mini-css-extract-plugin
export default {"ownerBadge":"ownerBadge_ownerBadge__ndep5"};